module.exports = __webpack_public_path__ + "static/media/WAGMI Index.b59549cb.png";